import React from "react";
import QrScanIcon from "../../icons/QrCode";
import styles from './ScanToStart.module.scss'
import { useTranslation } from "../../hooks/useTranslation";

const ScanToStart: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.iconWrapper}>
                    <QrScanIcon />
                </div>
                <h1 className={styles.heading}>{t('pages:scanToStart:heading')}</h1>
                <p className={styles.subtitle}>
                    {t('pages:scanToStart:subTitle')}
                </p>
            </div>
            <p className={styles.footer}>
                {t('pages:scanToStart:footer:text')}
            </p>
        </div>
    );
}

export default ScanToStart
